<template>
    <section class="esesja-modal">
        <section class="esesja-modal__wraper">
            <section class="esesja-modal__wraper__header">
                <h3 class="esesja-modal__wraper__header__title">{{$t('com.file.header-user-info.change-pin')}}</h3>
                <button class="esesja-modal__wraper__header__exit-btn"
                        @click=" (e)=>{e.preventDefault(); this.$store.commit('hidehowUserChangeOwnPinModal');}">
                    <img src="@/assets/icons/components/exit-btn.svg" />
                </button>
            </section>
            <perfect-scrollbar class="esesja-modal__wraper__body">
                <section class="esesja-modal__wraper__body__fallback-error" v-if="changePinError">
                    <img src="@/assets/icons/components/exit-btn.svg" class="esesja-modal__wraper__body__fallback-error__icon" :alt="$t('com.file.user-reset-password.error-icon')" />
                    <span class="esesja-modal__wraper__body__fallback-error__text">
                        {{$t('com.file.app-locked.check-data')}}
                    </span>
                </section>
                <label class="esesja-modal__wraper__body__label">{{$t('com.file.change-own-pin.pass-to-account')}}</label>
                <section class="esesja-modal__row">
                    <input class="esesja-modal__wraper__body__input"
                           type="password"
                           v-model="request.password"
                           :placecholder="$t('com.file.change-own-pin.current-password')"
                           v-error="{ errors, input_key: 'password' }" />
                    <ErrorMessage v-if="isError('oldPassword', this.errors)"
                                  :errorMsgs="passErrorMsg('password', this.errors)" />
                </section>

                <label class="esesja-modal__wraper__body__label">{{$t('com.file.change-own-pin.new-pin')}}</label>
                <section class="esesja-modal__row">
                    <section style="display: flex"  :data-tip="$t('com.file.change-own-pin.pin-min-6-numbers')">
                        <input class="esesja-modal__wraper__body__input"
                               :type="passwordFieldType"
                               v-model="request.pin"
                               :placecholder="$t('com.file.change-own-pin.new-pin')"
                               v-error="{ errors, input_key: 'pin' }" />
                    </section>
                    <ErrorMessage v-if="isError('pin', this.errors)"
                                  :errorMsgs="passErrorMsg('pin', this.errors)" />
                </section>

                <label class="esesja-modal__wraper__body__label">{{$t('com.file.change-own-pin.repeat-new-pin')}}</label>
                <section class="esesja-modal__row">
                    <section style="display: flex" :data-tip="$t('com.file.change-own-pin.pin-min-6-numbers')">
                        <input class="esesja-modal__wraper__body__input"
                               :type="passwordFieldType"
                               v-model="request.confirmPin"
                               :placecholder="$t('com.file.change-own-pin.new-pin')"
                               v-error="{ errors, input_key: 'confirmPin' }" />
                    </section>
                    <ErrorMessage v-if="isError('confirmPin', this.errors)"
                                  :errorMsgs="passErrorMsg('confirmPin', this.errors)" />
                </section>

                <section class="esesja-modal__wraper__body__bottom">
                    <button class="esesja-modal__wraper__body__bottom-button" @click="this.$store.commit('hidehowUserChangeOwnPinModal')">{{$t('com.global.cancel')}}</button>
                    <button class="esesja-modal__wraper__body__bottom-button esesja-modal__wraper__body__bottom-button--red" @click="changePin">{{$t('com.global.save')}}</button>
                </section>
            </perfect-scrollbar>
        </section>
        <LoaderInside v-if="isLoading" />
    </section>
</template>
<script charset="utf-8">
    import ErrorMessage from "@/components/BasicControls/ErrorMessage.vue";
    import {
        passErrorMsg,
        isError,
        setErrors,
    } from "@/formValidation/main";
    import UserService from "../../../../../services/user.service";

    export default {
        name: "ChangeOwnPin",
        components: {
            ErrorMessage
        },
        data() {
            return {
                request: {
                    password: "",
                    pin: "",
                    confirmPin: "",
                },
                errors: [],
                changePinError: false,
            }
        },
        methods: {

            async changePin() {
                try {
                    this.changePinError = false;
                    this.$store.commit("showLoader");
                    if (!this.validate()) {
                        return;
                    }

                    let response = await UserService.updateOwnPin(this.request);

                    if (response.status !== 200) {
                        throw await Promise.reject(response);
                    }

                    this.changePinError = !response.data;
                    if (response.data === true) {
                        this.$store.commit('hidehowUserChangeOwnPinModal');
                        return;
                    }

                }
                catch (e) {
                    console.log(e)
                    this.changePinError = true;
                    if (e.response.status == 404) {
                        this.$router.push({ name: 'notfoundpage', params: { pathMatch: 'sms' } });
                    }
                    else if (e.response.status == 401) {
                        this.$router.push({ name: 'Login' })
                    }
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },

            validate() {
                var validateStatus = true;
                var errors = {};

                if (this.request.password.length <= 0) {
                    validateStatus = false;
                    errors.password = [this.$t('com.global.required-field')]
                }

                if (this.request.pin.length < 6) {
                    validateStatus = false;
                    errors.pin = [this.$t('com.validation-error.pin-length-error')]
                }

                if (this.request.confirmPin.length < 6) {
                    validateStatus = false;
                    errors.confirmPin = [this.$t('com.validation-error.pin-length-error')]
                }
                else {
                    if (this.request.pin !== this.request.confirmPin) {
                        validateStatus = false;
                        errors.pin = [this.$t('com.validation-error.pin-not-equals-error')]
                        errors.confirmPin = [this.$t('com.validation-error.pin-not-equals-error')]
                    }
                }
                if (!validateStatus) {
                    this.isLoading = false;
                    this.errors = setErrors(errors)
                }
                return validateStatus;
            },
            passErrorMsg,
            setErrors,
            isError,
        }
    }
</script>
<style lang="scss" scoped>
    @use '@/assets/scss/esesja-modal.scss';
    @use  '@/assets/scss/esesja-data-tip.scss';
</style>